import { Checkbox } from "@progress/kendo-react-inputs";

export const IsTabProperty = {
  propertyName: "IsTab",
  propertyDisplay: "Layout as a Tab?",
  propertyType: "boolean",
  propertyCategory: "Layout",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <Checkbox
        name={this.propertyName}
        onChange={(e) => {
          handlePropertyChange({ propName: this.propertyName, propValue: e.target.value });
          handlePropertyChange({ propName: "VisibilityRules", propValue: [] });
        }}
        defaultValue={currentPropertyValues?.[this.propertyName] || false}
      />
    );
  },
};
